import React from 'react';
import PropTypes from 'prop-types';
import {
  TabContent,
  TabPane,
} from 'reactstrap';

import AdminRoleEditMainEdit from './MainEdit';
import AdminRoleEditCapabilitiesEdit from './CapabilitiesEdit';

const AdminRoleEditTabContent = ({
  roleId,
  activeTab,
  ...props
}) => (
  <TabContent activeTab={activeTab} className="settings-tab-content">
    <TabPane tabId="details">
      <AdminRoleEditMainEdit
        {...props}
      />
    </TabPane>
    <TabPane tabId="capabilities">
      {roleId && (
        <AdminRoleEditCapabilitiesEdit
          {...props}
        />
      )}
    </TabPane>
  </TabContent>
);

AdminRoleEditTabContent.propTypes = {
  roleId: PropTypes.string,
  activeTab: PropTypes.string.isRequired,
};

AdminRoleEditTabContent.defaultProps = {
  roleId: null,
};

export default AdminRoleEditTabContent;
